var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (initialState, resourceApp) {pug_html = pug_html + "\u003Cdiv class=\"resources-page\"\u003E\u003Cscript\u003E" + (null == (pug_interp = initialState) ? "" : pug_interp) + "\u003C\u002Fscript\u003E\u003Cdiv class=\"resource-app\"\u003E" + (null == (pug_interp = resourceApp) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"initialState" in locals_for_with?locals_for_with.initialState:typeof initialState!=="undefined"?initialState:undefined,"resourceApp" in locals_for_with?locals_for_with.resourceApp:typeof resourceApp!=="undefined"?resourceApp:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/resources/view/main.pug
// module id = 976
// module chunks = 0